export default __webpack_public_path__ + "static/media/upload-1.f6190241.svg";